export const endpointSk = {
  calendar: {
    root: 'calendar',
    option: 'calendar/option',
    update: 'calendar',
    delete: 'calendar/delete',
    report2pdf: 'calendar_pdf',
  },
  unit: {
    option: 'unit/option',
  },
  unitCalendar: {
    option: 'unitcalendar/option',
  },
  jadwalpelajaran: {
    root: 'jadwal',
    pagination: 'jadwal-pagination',
    option: 'jadwal/option',
    sesi: 'jadwal/sesike',
    jamkelas: 'jadwal/jamkelas',
    jadwalkelas: 'jadwal_pelajaran/per_kelas',
  },
  jadwal_guru: {
    option: 'jadwalguru/option',
    create: 'jadwalguru',
    update: 'jadwalguru',
    hapus: 'jadwalguru',
    // option: "jadwal/option",
  },
  parameter_jadwal: {
    root: 'parameter_jadwal',
  },
  bahasa: {
    root: 'bahasa',
    option: 'bahasa/option',
  },
  mapel: {
    root: 'mapels',
    export: 'mapel-export',
    option: 'mapels/option',
  },
  mapelekskur: {
    root: 'mapelekskur',
    option: 'mapelekskur/option',
  },
  mapil: {
    root: 'mapils',
    option: 'mapils/option',
    pilihan: 'mapelpilihan/option',
  },
  mapel_gabungan: {
    root: 'mapel-gabungan',
    parent: 'mapel-gabungan-parent',
  },
  mapelkelompok: {
    root: 'mapelkelompok',
    option: 'mapelkelompok/option',
  },
  mapelsubkelompok: {
    root: 'mapelsubkelompok',
    option: 'mapelsubkelompok/option',
  },
  jenjangunit: {
    root: 'jenjangunit',
  },
  jenjang: {
    root: 'jenjang',
    option: 'jenjang/option',
  },
  parallel: {
    root: 'parallel',
    sync: 'parallel/sync',
    option: 'parallel/option',
    detail: 'parallel/detail',
  },
  alokasiwaktu: {
    root: 'alokasiwaktu',
    option: 'alokasiwaktu/option',
  },
  kelas: {
    root: 'kelas',
    sync: 'kelas/sync',
    option: 'kelas/option',
  },
  menu: {
    root: 'menu',
    option: 'menu/option',
    action: 'menu/action',
  },
  school: {
    root: 'school',
    option: 'school/option',
  },
  tahun_pelajaran: {
    root: 'tahun-pelajaran',
    option: 'tahun-pelajaran/option',
  },
  export2excel: {
    report: 'export2excel',
  },
  vw_mapel: {
    select: 'vw_mapel',
  },
  tugasguru: {
    root: 'tugasguru',
    export: 'tugasguru-export',
    option: 'tugasguru/option',
  },
  tugastambahans: {
    root: 'tugastambahans',
    option: 'tugastambahans/option',
  },
  employee_guru: {
    root: 'employee_guru',
    option: 'employee_guru/option',
  },
  laporanalokasiwaktu: {
    root: 'laporan_alokasi_waktu',
    report: 'laporanalokasiwaktu',
  },
  laporan_alokasi_waktu: {
    report: 'laporan_alokasi_waktu',
  },
  laporanpembagiantugas: {
    report: 'laporanpembagiantugas',
  },
  laporan_pembagian_tugas: {
    report2pdf: 'laporan_pembagian_tugas_pdf',
    report2excel: 'laporan_pembagian_tugas_excel',
  },
  laporan_jadwal_pelajaran: {
    report: 'jadwal_pelajaran_kelas_pdf',
  },
};
export const apiSk = process.env.REACT_APP_API_SK;
